import { z } from 'zod';

import { zodDateOrString } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const GenerateManualStatementEvent = BaseLoanEvent.extend({
  type: z.literal('generateManualStatement'),
  principal: z.number(),
  interest: z.number(),
  escrow: z.number(),
  paymentDate: zodDateOrString,
});
export type GenerateManualStatementEvent = z.infer<typeof GenerateManualStatementEvent>;
